var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1OgranisationDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2020_1870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1771 2.25752L2.265 11.1696C0.153286 13.2813 0.153286 16.705 2.265 18.8168L11.1771 27.7288C13.2888 29.8405 16.7125 29.8405 18.8242 27.7288L27.7363 18.8168C29.848 16.705 29.848 13.2813 27.7363 11.1696L18.8242 2.25752C16.7125 0.145806 13.2888 0.145805 11.1771 2.25752Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4609 7.87894H46.6999",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4609 23.5002H46.6999",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9912 15.6896H46.6999",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6737 13.3682C20.5508 12.9313 20.3869 12.5216 20.1684 12.1393L21.1516 10.0774C20.7829 9.62677 20.3733 9.21713 19.9227 8.84844L17.8607 9.8316C17.4784 9.61312 17.0688 9.44926 16.6318 9.32637L15.8671 7.16888C15.5804 7.14157 15.2936 7.11426 15.0069 7.11426C14.7201 7.11426 14.4197 7.12791 14.1466 7.16888L13.3819 9.32637C12.9586 9.44926 12.5353 9.61312 12.153 9.8316L10.0911 8.84844C9.64045 9.21713 9.2308 9.62677 8.86211 10.0774L9.84527 12.1393C9.62679 12.5216 9.46293 12.9313 9.34004 13.3682L7.18255 14.1329C7.15524 14.4197 7.12793 14.7064 7.12793 14.9932C7.12793 15.2799 7.14159 15.5803 7.18255 15.8534L9.34004 16.6181C9.46293 17.0551 9.62679 17.4647 9.84527 17.8471L8.86211 19.909C9.2308 20.3596 9.64045 20.7692 10.0911 21.1379L12.153 20.1548C12.5353 20.3732 12.945 20.5371 13.3819 20.66L14.1466 22.8175C14.4333 22.8448 14.7201 22.8721 15.0069 22.8721C15.2936 22.8721 15.594 22.8585 15.8671 22.8175L16.6318 20.66C17.0688 20.5371 17.4784 20.3732 17.8607 20.1548L19.9227 21.1379C20.3733 20.7692 20.7829 20.3596 21.1516 19.909L20.1684 17.8471C20.3869 17.4647 20.5508 17.0551 20.6737 16.6181L22.8312 15.8534C22.8585 15.5667 22.8858 15.2799 22.8858 14.9932C22.8858 14.7064 22.8721 14.406 22.8312 14.1329L20.6737 13.3682V13.3682ZM12.3714 15.1024C12.3714 16.5499 13.5458 17.7242 14.9932 17.7242C16.4406 17.7242 17.615 16.5499 17.615 15.1024C17.615 13.655 16.4406 12.4807 14.9932 12.4807C13.5458 12.4807 12.3714 13.655 12.3714 15.1024Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2020_1870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3828,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1OgranisationDetails);
export default __webpack_public_path__ + "static/media/1-ogranisation-details.9de00e00e6e3929c2daf60ae6561e4eb.svg";
export { ForwardRef as ReactComponent };